import React from "react";

class SearchBar extends React.Component {
  // local searchTerm for controlled input element (ensures input's value/change is in React,
  // so not only in DOM)
  state = { searchTerm: "" };

  renderInput = () => {
    return (
      <div className="ui icon input">
        <input
          type="text"
          placeholder={this.props.hint}
          value={this.state.searchTerm}
          onChange={this.onChange}
        />
        <i className="search icon"></i>
      </div>
    );
  };

  onSubmit = formValues => {
    this.props.onSubmit(formValues.searchTerm); // parent callback
  };

  onChange = event => {
    const searchTerm = event.target.value;
    this.setState({ searchTerm });
    this.props.onChange(searchTerm);
  };

  render() {
    return (
      <form onSubmit={this.onSubmit} className="ui form">
        {this.renderInput()}
      </form>
    );
  }
}

SearchBar.defaultProps = {
  hint: "Search..."
};

export default SearchBar;
